import { BigNumber } from '@ethersproject/bignumber';
import { BigNumberWithDecimals, fromBigIntWithDecimals } from '@silo/types';
import { convertCurrency } from 'app/functions/silo/calculations';
import { usePriceInUSD } from 'app/queries/price/hooks';
import { SiloAsset } from 'queries/decoratedSilo';

interface UseAmountInUSDProps {
  selectedAsset: SiloAsset;
  normalizedAmount: BigNumber | null;
}

interface UseAmountInUSD {
  amountInUSD: BigNumberWithDecimals | null;
  priceInUSD: BigNumberWithDecimals | null;
}

export const useAmountInUSD = ({
  selectedAsset: { priceInNative, decimals },
  normalizedAmount,
}: UseAmountInUSDProps): UseAmountInUSD => {
  /**
   * @todo BigNumber-to-bigint
   */
  const priceInUSD = usePriceInUSD(priceInNative.toBigInt());

  if (!normalizedAmount || !priceInUSD) {
    return {
      priceInUSD: null,
      amountInUSD: null,
    };
  }

  const amount: BigNumberWithDecimals = {
    decimals,
    bigNumber: normalizedAmount,
  };

  const _priceInUSD = fromBigIntWithDecimals(priceInUSD);

  return {
    priceInUSD: _priceInUSD,
    amountInUSD: convertCurrency(amount, _priceInUSD),
  };
};
